module.exports = __webpack_public_path__ + "static/media/012-line-red.35c7acd3.svg";